import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useExtrasLogic from "./useExtrasLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "name", label: "Name", allowSorting: true },
  {
    field: "category",
    label: "Category",
    allowSorting: true,
    subvalue: "name",
    showInFilter: true,
  },
  { field: "limit", label: "Limit", allowSorting: false, decimalCount: 0 },
];

const ExtrasPage = () => {
  const { apiRoute, addRoles, editRoles, deleteRoles, initFields } =
    useExtrasLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      // Replace with your API endpoint to fetch the data

      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      await fetchDataAndMapToField(config, "addOnCategories", "category", temp);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Extras." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"addons"}
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        hasImport={true}
        importConfig={{
          relationshipMappings: [
            { field: "category", lookupTable: "addon_categories", lookupField: "name" }
          ]
        }}
      />
    </div>
  );
};

export default ExtrasPage;
